/* eslint-disable react/prop-types */
import { useRef } from 'react'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import {
  AdjustIcon,
  Cirlcle,
  SpanText,
  StyledUpload,
  TextWrapper,
  Wrapper,
  Normalext,
  BoldText,
  AutoFillText,
  UploadText
} from 'components/Uploader/Styles'
import RepeatIcon from 'components/icons/RepeatIcon'
import UploadIcon from 'components/icons/UploadIcon'
// import * as faceapi from 'face-api.js'
// import { PopupModel } from 'modules/DriveDetails/Style/SelectionStyle'
// import { UploadText } from '../../modules/OnBoarding/Register/PersonalInfo/style'
import { deleteFile, uploadFile } from '../OnBoarding/actions'
import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import { Spin } from 'antd'
import { UploadMarksheetButton } from '../OnBoarding/Register/Education/style'

const Uploader = ({
  isDelete,
  file,
  setFile,
  setIsUpdateButtonEnabled,
  isDefault = false,
  variant = 'default',
  label,
  showTextUploder,
  showButtonUploder,
  showIconUploader,
  fileName,
  onlyDoc = false,
  captureProfile,
  setIsModalOpen,
  isModalOpen,
  setError,
  profileUploadPage = false,
  width ='auto',
  height=  '96px',
  isCV = false
}) => {
  
  const [loading, setLoading] = useState(false)
  const [loadingSpinner, setLoadingSpinner] = useState(false)
  const dispatch = new useDispatch()
  const fileSize = onlyDoc ? 5 : 2
  const formats = onlyDoc ? 'pdf or doc/docx' : 'jpg/jpeg or pdf'
  const buttonText =
    label || (variant === 'simple' ? 'Upload Marksheet' : 'Upload File')
  const getFileUrl = async info => {
    console.log('raj2')
    let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
    let name = fileName
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.jpeg, .jpg , .png',
    beforeUpload: async file => {
      const isLt10mb = file.size / 1024 / 1024 < fileSize
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 2mb!')
        return false
      } else if (
        !(file?.type.includes('png') || file?.type?.includes('jpeg'))
      ) {
        ErrorMessage('File should be in jpg/jpeg or png format!')
        return false
      }
      // try {
      //   setLoading(true)
      //   await initFaceApi()

      //   const img = await faceapi.bufferToImage(file)
      //   const detections = await faceapi
      //     .detectAllFaces(img)
      //     .withFaceLandmarks()
      //     .withFaceDescriptors()

      //   if (detections.length > 0) {
      //     if (detections?.length > 1) {
      //       ErrorMessage('More than one face detected.')
      //       return false
      //     } else {
      //       return true
      //     }
      //   } else {
      //     ErrorMessage('Face is not detected.')
      //     console.log('No face detected.')
      //     return false
      //   }
      // } catch (error) {
      //   console.log('Error processing image:', error)
      //   console.log('Error processing image. Please try again.')
      //   return false
      // } finally {
      //   setLoading(false)
      // }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }
  const dummyRequest = ({ onSuccess }) => {
  setTimeout(() => {
    onSuccess('OK')
  }, 0)
  if (setIsModalOpen) {
    setIsModalOpen(prev => !prev)
  }
  if (setError) {
    setError(false)
  }
}
  const onBeforeUpload = file => {
    console.log(onlyDoc, file)
    const isLt10mb = file.size / 1024 / 1024 < fileSize
    if (!isLt10mb) {
      ErrorMessage(`File size must be smaller than ${fileSize} MB!`)
      return false
    }
      if (isCV) {
    if (file.type !== 'application/pdf') {
      ErrorMessage('Only PDF files are allowed for CV upload!')
      return false
    }
    return true
  } else if (
      !(
        file?.type.includes('pdf') ||
        file?.type === 'application/msword' || // for .doc
        file?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        (!onlyDoc && file?.type?.includes('jpeg')|| file?.type.includes('jpg')||file?.type.includes('pdf'))
      )
    ) {
      ErrorMessage(`File should be in  ${formats} format!`)
      return false
    } 
  }
  
  const initFaceApi = async () => {
    const basePath =
      'https://d39w34th2iwz5l.cloudfront.net/models/stu_profile_pic/'
    await faceapi.nets.ssdMobilenetv1.loadFromUri(basePath)
    await faceapi.nets.faceLandmark68Net.loadFromUri(basePath)
    await faceapi.nets.faceRecognitionNet.loadFromUri(basePath)
  }

  const onChangeFileUpload = async info => {
    if (setIsUpdateButtonEnabled) {
      setIsUpdateButtonEnabled(false)
    }
      if(isCV){
        setLoadingSpinner(true)
      }
    if (info?.file?.status === 'done') {
      const mime = info?.file?.type || ''
      const fname = (info?.file?.name && info?.file?.name.toLowerCase()) || ''
      let getType =
        mime.includes('pdf') || fname.endsWith('.pdf')
          ? 'pdf'
          : mime === 'application/msword' ||
            mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            mime.includes('word') ||
            mime.includes('doc') ||
            fname.endsWith('.doc') ||
            fname.endsWith('.docx')
          ? 'doc'
          : mime.includes('png') || fname.endsWith('.png')
          ? 'png'
          : 'jpg'
      let name = fileName

      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size || info?.file?.originFileObj?.size || 0,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
    if(isCV){
      setLoadingSpinner(false)
    }
  }
  const imageCapture = () => {
    captureProfile()
    setIsModalOpen(false)
    setError(false)
  }
if (variant === 'simple') {
  return (
    <StyledUpload
      name="file"
      multiple={false}
      accept={
        (fileName && fileName.includes('marksheet')) || (fileName && fileName.includes('certificate'))
          ? '.pdf, .jpeg'
          : isCV
          ? '.pdf'
          : onlyDoc
          ? '.doc, .docx, .pdf , .jpg'
          : '.jpeg, .jpg , .pdf'
      }
      customRequest={dummyRequest}
      beforeUpload={onBeforeUpload}
      onChange={onChangeFileUpload}
      showUploadList={false}
    >
      <UploadMarksheetButton type="button">
        {buttonText}
      </UploadMarksheetButton>
      <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
        Format (.jpg, .pdf) Max size: 2MB
      </div>
    </StyledUpload>
  )
}

  return (
    <Fragment>
      {isDefault && (
        <Wrapper center alignCenter column width={width} height={height}>
          {isCV && (
            <div style={{padding: '5px'}}>
              <BoldText>Auto-fill using resume</BoldText>
              <Normalext>Let your resume work for you! We’ll automatically fill your details.</Normalext>
            </div>
          )}
          <StyledUpload
            {...props}
            type="file"
            accept={(fileName && fileName.includes('marksheet')) || (fileName && fileName.includes('certificate')) ? '.pdf, .jpeg' : isCV ? '.pdf' : onlyDoc ? '.doc, .docx, .pdf , .jpg' : '.jpeg, .jpg , .pdf'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            beforeUpload={onBeforeUpload}
          >
           
            <Button.Secondary
              icon={
                <AdjustIcon>
                  <UploadIcon />
                </AdjustIcon>
              }
              text={isCV ? 'Continue with Resume' : 'Upload File'}
              height={'32px'}
              loading={loadingSpinner}
              disabled={loadingSpinner}
            />
          </StyledUpload>
          <TextWrapper center alignCenter>
            <SpanText mr={'4px'}>Note: </SpanText>
            <SpanText>Size: {onlyDoc ? '5' : '2'} mb max</SpanText> <Cirlcle />
            <SpanText>
              Format : {(fileName && fileName.includes('marksheet')) || (fileName && fileName.includes('certificate')) ? '.PDF, .JPEG' : isCV ? '.pdf' : onlyDoc ? '.DOC/.DOCX .PDF' : '.PDF, .JPEG/JPG'}
            </SpanText>
          </TextWrapper>
          {isCV && (
            <div style={{padding: '5px',marginTop:'10px'}}>
              <AutoFillText>Don’t have a resume? <span>You can fill the details below manually.</span></AutoFillText>
            
            </div>
          )}
        </Wrapper>
      )}
      {profileUploadPage && showTextUploder && (
          <Control center alignCenter top="5px">
            <UploadText
              onClick={() => {
                setIsModalOpen(true)
              }}
            >
              Upload Photo
            </UploadText>
          </Control>
      )}
      {!profileUploadPage && showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
            <Control center alignCenter top="5px">
              <UploadText
              // onClick={() => {
              //   setIsModalOpen(true)
              // }}
              >
                Upload Photo
              </UploadText>
            </Control>
        </StyledUpload>
      )}

      {profileUploadPage && showButtonUploder && (
        <Button.Primary
          text="Change Image"
          height={'32px'}
          onClick={() => setIsModalOpen(!isModalOpen)}
        />
      )}
      {!profileUploadPage && showButtonUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Button.Primary text="Change Image" height={'32px'} />
        </StyledUpload>
      )}
      {showIconUploader && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <RepeatIcon />
        </StyledUpload>
      )}
      {isModalOpen && (
        <PopupModel
          open={isModalOpen}
          footer={null}
          closable={!loading}
          onCancel={() => setIsModalOpen(false)}
          width={'590px'}
          bodyStyle={{
            alignItems: 'center',
            gap: '3em',
          }}
        >
          <div
            style={{
              fontSize: '1.3em',
              letterSpacing: '0.08em',
              fontWeight: '600',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            Would you like to choose
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10%',
              justifyContent: 'center',
              margin: '3em',
            }}
          >
            <StyledUpload {...props} type="file" customRequest={dummyRequest}>
              <Button.Primary
                text="Upload Photo"
                height="3.5em"
                width="10em"
                disabled={loading}
                loading={loading}
              />
            </StyledUpload>
            <div
              style={{
                fontSize: '1.2em',
                letterSpacing: '0.1em',
                fontWeight: '600',
              }}
            >
              or
            </div>
            <Button.Primary
              text="Capture Photo"
              height="3.5em"
              width="10em"
              disabled={loading}
              onClick={imageCapture}
            />
          </div>
        </PopupModel>
      )}
    </Fragment>
  )
}

export default Uploader
